<template>
  <el-select
    v-model="input"
    placeholder="Enter name of Portfolio"
    multiple
    filterable
    class="w-100"
    placement="top"
    clearable
    :loading="isLoading"
    :disabled="disabled"
    @select="handleSelect"
    @clear="clearInput"
  >
    <el-option
      v-for="item in data"
      :key="item.id"
      :label="item.long"
      :value="item.id"
    />
  </el-select>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      input: '',
      data: [],
      isLoading: false
    }
  },
  created () {
    this.loadPortfolios()
    if (this.value.id) {
      this.input = this.value.name
    }
  },
  methods: {
    loadPortfolios (queryString) {
      this.isLoading = true
      this.$sdk.dictionary_portfolio.list(builder => {
        builder.limit = 500
      }).then(res => {
        this.data = res
        this.isLoading = false
      })
    },
    handleSelect (item) {
      this.input = item.long
      this.$emit('input', item)
    },
    clearInput () {
      this.input = ''
      this.$emit('input', {})
    },
    getPortfolioId () {
      return this.input
    }
  }
}
</script>

<style>

</style>
